import React from 'react';

import { WarrantySummaryFragmentProps } from './WarrantySummaryFragment.props';
import { WarrantyPanal } from '../../../../components/molecules/WarrantyPanel';

export const WarrantySummaryFragment: React.FC<WarrantySummaryFragmentProps> = ({
  warrantySummarydata,
  firstInstalled
}) => {
  return (
    <>
      <WarrantyPanal
        warrantyPanalData={warrantySummarydata}
        firstInstalled={firstInstalled}
      />
    </>
  );
};